import { EnvironmentProviders, inject, Injectable, InjectionToken, makeEnvironmentProviders, Type } from '@angular/core';

export interface IQPointNumberFormatService {
    formatUnit(unitSign: string): string;
}

export const DI_NUMBER_FORMAT_SERVICE = new InjectionToken<IQPointNumberFormatService>('QPointNumberFormatService');

export function provideNumberFormatService(useClass: Type<IQPointNumberFormatService>): EnvironmentProviders {
    return makeEnvironmentProviders([{
      provide: DI_NUMBER_FORMAT_SERVICE,
      useClass
    }]);
}

export function injectNumberFormatService(): IQPointNumberFormatService {
    return inject(DI_NUMBER_FORMAT_SERVICE, {optional: true}) ?? new DefaultNumberFormatService();
}

@Injectable({
    providedIn: "root"
})
export class DefaultNumberFormatService implements IQPointNumberFormatService {
    private unitFormatMap = new Map<string, string>([
        ["t", ",0.00"],
        ["m³", ",0.00"],
        ["t/m³", ",0.000"],
        ["kg/m³", ",0"],
        ["g/cm³", ",0.000"]
    ]);

    constructor() {
    }

    formatUnit(unitSign: string): string {
        return this.unitFormatMap.get(unitSign) ?? ",0";
    }
}